import { Table } from "antd";
import React from "react";

export const TableGeneral = ({
    column = [],
    state = [],
    handleChange = (pagination, filters, sorter) => { },
    pagination = {
        position: ["none", "none"],
        pageSize: 200,
    },
    loading = false,
    tableProps = {},
    scrollX = 1600
}) => {
    return (
        <Table
            scroll={{ x: scrollX }}
            loading={loading}
            columns={column}

            dataSource={state}
            pagination={pagination}
            onChange={handleChange}
            {...tableProps}
        />
    );
};
